import mutations from './mutations'
import * as actions from './actions'
import * as getters from './getters'

const initialState = {
  offerToSells: [],
  invoiceTemplateId: 1,
  selectedOfferToSells: [],
  selectAllField: false,
  selectAllFieldAttachment: false,
  totalOfferToSells: 0,
  selectedCustomer: null,
  attachments: [],
  attachmentSize: null,
  totalAttachments: 0,
  selectedAttachments: [],
  selectedPreapprovedInvoice:0,
}

export default {
  namespaced: true,

  state: initialState,

  getters: getters,

  actions: actions,

  mutations: mutations
}
